var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnMuteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "92px",
    height: "92px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "11px",
    stroke: "rgb(0, 97, 174)",
    fill: "rgb(255, 237, 0)",
    d: "M45.602,18.499 C60.571,18.499 72.705,30.634 72.705,45.602 C72.705,60.571 60.571,72.705 45.602,72.705 C30.634,72.705 18.500,60.571 18.500,45.602 C18.500,30.634 30.634,18.499 45.602,18.499 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0, 97, 174)",
    d: "M56.558,52.582 C56.62,53.109 55.238,53.130 54.717,52.628 C54.196,52.126 54.175,51.292 54.671,50.765 C57.75,48.220 57.75,44.211 54.671,41.666 C54.175,41.138 54.196,40.304 54.717,39.802 C55.238,39.301 56.62,39.321 56.558,39.849 C59.921,43.411 59.921,49.19 56.558,52.582 ZM49.974,59.390 L47.996,59.390 C47.206,59.389 46.459,59.26 45.966,58.402 L41.541,52.806 L35.660,52.806 C34.222,52.806 33.57,51.627 33.57,50.172 L33.57,42.271 C33.57,40.817 34.222,39.638 35.660,39.638 L41.541,39.638 L45.966,34.42 C46.459,33.418 47.206,33.54 47.996,33.54 L49.974,33.54 C51.411,33.54 52.576,34.233 52.576,35.688 L52.576,56.756 C52.576,58.211 51.411,59.390 49.974,59.390 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMuteButton);
export default __webpack_public_path__ + "static/media/unMuteButton.4358b143.svg";
export { ForwardRef as ReactComponent };